module.exports = __webpack_public_path__ + "img/boat20.65d3689e.png";